// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__62df5","toggle":"styles_toggle__SyQdn","preview":"styles_preview__3yo8m"};